import { simpleMetadataDecoratorApplicator } from "@spscommerce/utils";
import { Observable } from "rxjs";

export interface ModalActionConfig {
    label: string | ((componentInstance: any) => string);
    enabled?: boolean | ((componentInstance: any) => boolean);
}

export interface ModalActionMethod {
    (...args: any[]): void | boolean | Observable<void | boolean> | Promise<void | boolean>;
    label: string;
    enabled?: boolean;
    isActive?: boolean;
}

const MODAL_ACTION_DEFAULTS: ModalActionConfig = {
    label: "",
    enabled: true
};

export function ModalAction(config: ModalActionConfig): MethodDecorator {
    return (
        target: any,
        key: PropertyKey,
        descriptor: TypedPropertyDescriptor<any>
    ): TypedPropertyDescriptor<any> =>
        simpleMetadataDecoratorApplicator<ModalActionConfig, any>(
            config,
            MODAL_ACTION_DEFAULTS,
            target,
            key,
            descriptor
        );
}
